import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import type { SortField, SortDirection } from "./userUtils";

interface UserTableHeaderProps {
  sortField: SortField;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
}

function SortIcon({
  field,
  currentField,
  direction,
}: {
  field: SortField;
  currentField: SortField;
  direction: SortDirection;
}) {
  if (currentField !== field) {
    return <ArrowUpDown className="ml-1 h-4 w-4 text-ink-400" />;
  }
  return direction === "asc" ? (
    <ArrowUp className="ml-1 h-4 w-4 text-ink-600" />
  ) : (
    <ArrowDown className="ml-1 h-4 w-4 text-ink-600" />
  );
}

export function UserTableHeader({
  sortField,
  sortDirection,
  onSort,
}: UserTableHeaderProps) {
  return (
    <thead className="bg-grid-50 text-left text-sm text-ink-600">
      <tr>
        <th className="px-6 py-3">
          <button
            onClick={() => onSort("email")}
            className="flex items-center font-medium hover:text-ink-900"
          >
            Email
            <SortIcon
              field="email"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-3 text-center">
          <button
            onClick={() => onSort("registered")}
            className="flex items-center justify-center font-medium hover:text-ink-900 mx-auto"
          >
            Registered
            <SortIcon
              field="registered"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-3">
          <button
            onClick={() => onSort("createdDate")}
            className="flex items-center font-medium hover:text-ink-900"
          >
            Created At
            <SortIcon
              field="createdDate"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-3">
          <button
            onClick={() => onSort("lastUpdated")}
            className="flex items-center font-medium hover:text-ink-900"
          >
            Last updated
            <SortIcon
              field="lastUpdated"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-3 font-medium">Categories</th>
        <th className="px-6 py-3">
          <button
            onClick={() => onSort("role")}
            className="flex items-center font-medium hover:text-ink-900"
          >
            Role
            <SortIcon
              field="role"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-3 w-16">
          <span className="sr-only">Actions</span>
        </th>
      </tr>
    </thead>
  );
}
